<template>
  <div class="limit_row">
    <div class="limit_row_head">
      <span class="limit_row_label">{{ label }}</span>
      <span class="limit_row_value">
        <template v-if="isUnlimited">{{ $t('modals.limit.unlimited') }}</template>
        <template v-else>
          <b>{{ used }}</b> {{ $t('modals.limit.of') }} {{ limit }}
          {{ $t('modals.limit.sites') }}
        </template>
      </span>
    </div>
    <div class="limit_bar" v-if="!isUnlimited">
      <div
        class="limit_bar_fill"
        :class="{ full: percent >= 100 }"
        :style="{ width: `${percent}%` }"
      ></div>
    </div>
    <div class="limit_row_reset" v-if="resetsAt">
      {{ $t('modals.limit.resetsAt') }} {{ resetsAt }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LimitRow',
  props: {
    label: String,
    // { used, limit, resetsAt } из ответа бэкенда; limit -1 = без лимита
    window: Object,
  },
  computed: {
    used() {
      return this.window?.used ?? 0
    },
    limit() {
      return this.window?.limit ?? 0
    },
    isUnlimited() {
      return this.limit < 0
    },
    percent() {
      if (this.isUnlimited || !this.limit) return 0
      return Math.min(100, Math.round((this.used / this.limit) * 100))
    },
    resetsAt() {
      if (!this.window?.resetsAt) return ''
      const date = new Date(this.window.resetsAt)
      if (Number.isNaN(date.getTime())) return ''
      // Показываем в локальном времени пользователя, на бэкенде граница в UTC
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date)
    },
  },
}
</script>

<style scoped>
.limit_row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.limit_row_head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 14px;
  color: var(--text-primary);
}
.limit_row_label {
  font-weight: 600;
}
.limit_row_value {
  color: var(--text-secondary);
}
.limit_row_value b {
  color: var(--text-primary);
}
.limit_bar {
  height: 6px;
  border-radius: 3px;
  background: var(--bg-surface-3);
  overflow: hidden;
}
.limit_bar_fill {
  height: 100%;
  border-radius: 3px;
  background: var(--button-primary, var(--main-color));
  transition: width 0.3s ease;
}
.limit_bar_fill.full {
  background: var(--button-pink, #f45b69);
}
.limit_row_reset {
  font-size: 12px;
  color: var(--text-secondary2);
}
</style>
